<template>
  <div id="salesmanList" v-loading="exportLoading">
    <el-card>
      <!-- 查询选项 -->
      <Form class="salesmanForm" :label-width="160">
        <FormItem class="form_item" :label="$t('projectName1')">
          <Input clearable v-model="projectName" :placeholder="$t('enter')"/>
        </FormItem>
        <FormItem class="form_item" :label="$t('projectNumber1')">
          <Input clearable v-model="projectNumber" :placeholder="$t('enter')"/>
        </FormItem>
        <FormItem class="form_item" :label="$t('serviceContractNo2')">
          <Input clearable v-model="serviceContractNo" :placeholder="$t('enter')"/>
        </FormItem>
        <FormItem class="form_item" :label="$t('taskNumber1')">
          <Input clearable v-model="taskNumber" :placeholder="$t('enter')"/>
        </FormItem>
        <FormItem class="form_item" :label="$t('subtaskNumber1')">
          <Input clearable v-model="subtaskNumber" :placeholder="$t('enter')"/>
        </FormItem>
        <FormItem class="form_item" :label="$t('actualDeliveryEngineer2')">
          <el-select v-model="createUser" clearable filterable remote :remote-method="remoteEngineer">
            <el-option v-for="item in EngineerList" :key="item.empCode" :label="item.userCode" :value="item.empCode"></el-option>
          </el-select>
        </FormItem>
        <FormItem class="form_item" :label="$t('country1')" v-if="queryShow">
          <el-select filterable v-model="country" clearable>
            <el-option v-for="item in CountryList" :key="item.sysValue" :label="item.sysValue" :value="item.sysValue"></el-option>
          </el-select>
        </FormItem>
        <FormItem class="form_item" :label="$t('department1')" v-if="queryShow">
          <el-select filterable v-model="department" clearable>
            <el-option v-for="item in DeptList" :key="item.deptCode" :label="item.deptEnName" :value="item.deptCode"></el-option>
          </el-select>
        </FormItem>
        <FormItem class="form_item" :label="$t('labourStatus1')" v-if="queryShow">
          <el-select v-model="flagStatus" clearable>
            <el-option v-for="item in StatusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </FormItem>
        <FormItem class="form_item" :label="$t('workDate1')" v-if="queryShow" style="margin-right: 100px;">
          <el-date-picker v-model="workTime" :editable="true" clearable type="daterange" value-format="yyyy-MM-dd" :start-placeholder="$t('beginTime')" 
            :end-placeholder="$t('endTime')" style="width: 250px;"></el-date-picker>
        </FormItem>
        <div class="buttonDiv">
          <el-button type="primary" size="mini" @click="advancedFilter">{{$t('advancedFilter')}}</el-button>
          <el-button type="primary" size="mini" icon="el-icon-search" @click="searchLabourHourByPage" :loading="searchLoading">{{$t('search')}}</el-button>
          <el-button v-has="{class:'labourBatch'}" type="primary" size="mini" @click="batchInfo">{{$t('batchEdit')}}</el-button>
          <el-button v-has="{class:'labourExport'}" type="primary" size="mini" icon="el-icon-download" @click="exportExcel">{{$t('export')}}</el-button>
          <!-- <el-button v-has="{class:'labourAdd'}" type="primary" size="mini" icon="el-icon-plus" @click="addInfo">{{$t('add')}}</el-button> -->
        </div>
      </Form>
      <div class="contentTableDiv">
        <el-table :data="hourTotal" border style="width:100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
          <el-table-column prop="workContent" :label="$t('hourEntry')" align="center" :show-overflow-tooltip="true" min-width="110"></el-table-column>
          <el-table-column prop="workHours" :label="$t('workSummary')" align="center" :show-overflow-tooltip="true" min-width="110"></el-table-column>
          <el-table-column prop="travelHours" :label="$t('travelSummary')" align="center" :show-overflow-tooltip="true" min-width="130"></el-table-column>
          <el-table-column prop="workDescribe" :label="$t('totalHours')" align="center" :show-overflow-tooltip="true" min-width="110" ></el-table-column>
        </el-table>
      </div>
      <div class="contentTableDiv">
        <el-table :data="tableData" @selection-change="handleSelectionChange" border style="width:100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column prop="id" v-if="false"></el-table-column> 
          <!-- <el-table-column prop="labourHourId" :label="$t('labourHourId')" align="center" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <a style="color:blue;" @click="handleNavigation(scope.row)">{{scope.row.labourHourId}}</a>
            </template>
          </el-table-column> -->
          <el-table-column prop="workContent" :label="$t('workContent')" align="left" :show-overflow-tooltip="true" min-width="250">
            <template slot-scope="scope">
              <a style="color:blue;" @click="handleNavigation(scope.row)">{{scope.row.workContent}}</a>
            </template>
          </el-table-column>
          <el-table-column prop="workDescribe" :label="$t('workDescribe')" align="left" :show-overflow-tooltip="true" min-width="180"></el-table-column>
          <el-table-column prop="workHours" :label="$t('workHours')" align="center" :show-overflow-tooltip="true" min-width="110"></el-table-column>
          <el-table-column prop="travelHours" :label="$t('travelHours')" align="center" :show-overflow-tooltip="true" min-width="130"></el-table-column>
          <el-table-column prop="workDate" :label="$t('workDate')" width="110" align="center"></el-table-column>
          <el-table-column prop="createUser" :label="$t('actualDeliveryEngineer')" align="center" width="200" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="projectName" :label="$t('projectName')" align="left" :show-overflow-tooltip="true" min-width="150">
              <template slot-scope="scope">
              <a style="color:blue;" @click="handleProject(scope.row)">{{scope.row.projectName}}</a>
            </template>
          </el-table-column>
          <el-table-column prop="taskName" :label="$t('taskName')" align="left" :show-overflow-tooltip="true" min-width="180">
            <template slot-scope="scope">
              <a style="color:blue;" @click="handleTask(scope.row)">{{scope.row.taskName}}</a>
            </template>
          </el-table-column>
          <el-table-column prop="subtaskName" :label="$t('subtaskName')" align="left" :show-overflow-tooltip="true" min-width="180">
            <template slot-scope="scope">
              <a style="color:blue;" @click="handleSubtask(scope.row)">{{scope.row.subtaskName}}</a>
            </template>
          </el-table-column>
          <el-table-column :label="$t('operate')" fixed="right" width="160" align="center">
            <template slot-scope="scope">
              <el-button v-has="{class:'labourUpdate'}" v-if="scope.row.flagStatus=='0'" size="mini" type="primary" @click="handleEdit(scope.row)">{{$t('update')}}</el-button>
              <el-button v-has="{class:'labourDelete'}" v-if="scope.row.flagStatus=='0'" size="mini" type="danger" @click="handleDelete(scope.row)">{{$t('delete')}}</el-button>
            </template>
          </el-table-column>
        </el-table> 
      </div>
      <div class="pageDiv">
        <el-pagination small @size-change="changePageSize" @current-change="changePage" :current-page="currentPage" :page-sizes="[10, 20,50,100]"
          :page-size="pageSize" layout="total, prev, pager, next, sizes, jumper" :total="totalCount">
        </el-pagination>
      </div>
    </el-card>
    <Modal v-model="modelBatch" :closable='true' :mask-closable='false' :title="$t('batchEdit')">
      <div slot="footer">
        <Button type="primary" size="small" @click="close">{{$t('cancle')}}</Button>
        <Button type="primary" size="small" @click="submitUnfrozenForm('batchForm')">{{$t('batchUnfrozen')}}</Button>
        <Button type="primary" size="small" @click="submitFrozenForm('batchForm')">{{$t('batchFrozen')}}</Button>
      </div>
      <el-form :model="batchForm" ref="batchForm" :rules="rules">
          <el-row>
            <el-col :xs="24" :md="24">
              <el-form-item :label="$t('workMonth1')" prop="frozenMonth" >
                <el-date-picker v-model="batchForm.frozenMonth" :picker-options="pickerOptions" :editable="true" clearable type="month" 
                  value-format="yyyy-MM" style="width: 270px;"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
      </el-form>
    </Modal>
  </div>
</template>
<script>
    import * as validate from '@/utils/validate'

    export default {
        name: 'labour',
        activated () {
          let toLabour = this.$route.params.toLabour;
          if(toLabour == 'N' || JSON.stringify(this.$route.params)=='{}'){
            this.getLabourHourByPage();
          }
        },
        created () {
          // this.getParams();
          this.getLabourHourByPage();
          this.getDeliveryEngineerList();
          this.getCountry();
          this.getDeptList();
        },
        data () {
          return {
            pickerOptions: {disabledDate: time => {return this.selectWorkDate(time)}},
            rangeNumber: 10,
            projectName:null,
            projectNumber:null,
            serviceContractNo:null,
            taskNumber:null,
            subtaskNumber:null,
            createUser:null,
            country:null,
            department:null,
            flagStatus:null,
            workTime:[],
            //other
            modelBatch:false,
            exportLoading:false,
            queryShow:false,
            currentPage: 1,
            totalCount: 0,
            pageSize: 10,
            multipleSelection: [],
            CountryList:[],
            DeptList:[],
            EngineerList:[],
            LaborEngineerList:[],
            hourTotal: [],
            tableData: [],
            StatusList:[
              { value: '0',label: 'Delivering'},
              { value: '1',label: 'Frozen'},
              { value: '3',label: 'Closed'},
            ],
            batchForm:{
              frozenMonth:null,
            },
            rules: {
              frozenMonth: [
                { required: true, message:'Please select date', trigger: 'change' },
              ],
            },
            searchLoading: false,
          }
        },
        methods: {
          getParams(){
            let id = this.$route.params.id;
            if(id != undefined && id != null && id != ''){
              let params = this.$route.params;
              this.currentPage = params.currentPage;
              this.pageSize = params.pageSize;
              this.projectName = params.projectName;
              this.projectNumber = params.projectNumber;
              this.serviceContractNo = params.serviceContractNo;
              this.taskNumber = params.taskNumber;
              this.subtaskNumber = params.subtaskNumber;
              this.workTime = params.workTime;
              this.createUser = params.createUser;
              this.country = params.country;
              this.department = params.department;
              this.flagStatus = params.flagStatus;
            }
          },
          getCountry(){
            let url =`${this.$store.state.islhurl}keyValue/getSelectData`;
            let pm = {
              sysKey: 'Country',
              delFlg: '0',
            }
            this._post(url,pm).then(
              res => {   
                this.CountryList = res.data;
              }
            )
          },
          getDeptList(){
            let url =`${this.$store.state.islhurl}dept/getSelectData`;
            let pm = {
              deptCodechain: 'SelectDept',
            }
            this._post(url,pm).then(
              res => {   
                this.DeptList = res.data;
              }
            )
          },
          getDeliveryEngineerList(){
            let url =`${this.$store.state.islhurl}user/getSelectDeliveryEngineer`;
            this._post(url).then(
              res => {   
                this.LaborEngineerList = res.data;
                this.EngineerList = res.data;
              }
            )
          },
          getLabourHourByPage(){
            let projectId = this.$route.params.projectNumber;
            if(projectId != undefined && projectId != null && projectId != ''){
              this.projectNumber = projectId;
            }
            let taskId = this.$route.params.taskNumber;
            if(taskId != undefined && taskId != null && taskId != ''){
              this.taskNumber = taskId;
            }
            let subtaskId = this.$route.params.subtaskNumber;
            if(subtaskId != undefined && subtaskId != null && subtaskId != ''){
              this.subtaskNumber = subtaskId;
            }
            let workTime1 = null,workTime2 = null;
            if(this.workTime != null && this.workTime != '' && this.workTime.length > 0){
              workTime1 = this.workTime[0];
              workTime2 = this.workTime[1];
            }
            let url = `${this.$store.state.islhurl}getLabourHourInfoGroup/${this.pageSize}/${this.currentPage}`
            let pm = {
              projectId: this.projectNumber==''?null:this.projectNumber,
              taskId: this.taskNumber==''?null:this.taskNumber,
              subtaskId: this.subtaskNumber==''?null:this.subtaskNumber,
              workTime1: workTime1,
              workTime2: workTime2,
              projectName: this.projectName==''?null:this.projectName,
              serviceContractNo: this.serviceContractNo==''?null:this.serviceContractNo,
              createUser: this.createUser==''?null:this.createUser,
              country: this.country==''?null:this.country,
              dept: this.department==''?null:this.department,
              flagStatus: this.flagStatus==''?null:this.flagStatus,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            this._post(url,pm).then(
              res =>{
                this.hourTotal = res.hourTotal;
                this.tableData = res.data;
                this.totalCount = res.totalNums;
              }
            )
          },
          searchLabourHourByPage(){
            this.pageSize = 10;
            this.currentPage = 1;
            let workTime1 = null,workTime2 = null;
            if(this.workTime != null && this.workTime != '' && this.workTime.length > 0){
              workTime1 = this.workTime[0];
              workTime2 = this.workTime[1];
            }
            let url = `${this.$store.state.islhurl}getLabourHourInfoGroup/${this.pageSize}/${this.currentPage}`
            let pm = {
              projectId: this.projectNumber==''?null:this.projectNumber,
              taskId: this.taskNumber==''?null:this.taskNumber,
              subtaskId: this.subtaskNumber==''?null:this.subtaskNumber,
              workTime1: workTime1,
              workTime2: workTime2,
              projectName: this.projectName==''?null:this.projectName,
              serviceContractNo: this.serviceContractNo==''?null:this.serviceContractNo,
              createUser: this.createUser==''?null:this.createUser,
              country: this.country==''?null:this.country,
              dept: this.department==''?null:this.department,
              flagStatus: this.flagStatus==''?null:this.flagStatus,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            this.searchLoading = true
            this._post(url,pm).then(
              res =>{
                this.hourTotal = res.hourTotal;
                this.tableData = res.data;
                this.totalCount = res.totalNums;
                this.searchLoading = false
              }
            ).catch(e => {
              this.searchLoading = false
            })
          },
          addInfo() {
            this.$router.push({path:'/labour/add'});
          },
          handleNavigation(index){
            let pm = {
              id: index.id,
              showRun:'Y',
            }
            this.$router.push({name:'labour_detail',params:pm})
          },
          handleEdit(index) {
            let pm = {
              id: index.id,
              taskId: index.taskId,
              currentPage: this.currentPage,
              pageSize: this.pageSize,
              workContent: this.workContent,
            }
            this.$router.push({name:'labour_edit',params:pm})
          },
          handleProject(index){
            let pm = {
              projectNumber: index.projectId,
            }
            this.$router.push({name:'project_detail',params:pm});
          },
          handleTask(index){
            let pm = {
              taskNumber: index.taskId,
            }
            this.$router.push({name:'task_detail',params:pm});
          },
          handleSubtask(index){
            let pm = {
              subtaskNumber: index.subtaskId,
            }
            this.$router.push({name:'subtask_detail',params:pm});
          },
          handleDelete(index){
            this.$confirm("Are you sure to delete the labour hour", "Warning", {
              confirmButtonText: 'Confirm',
              cancelButtonText: 'Cancel',
              type: 'warning'
            }).then(() => {
              let params = {
                id:index.id,
                islhToken : sessionStorage.getItem('islhtoken'),
              }
              let url = `${this.$store.state.islhurl}labourHour/deleteInfo`
              this._post(url,params).then(
                res =>{
                  if(res=="200"){
                    this.getLabourHourByPage();
                    this.$Message.success('Labour Hour Delete Successful' )
                  }else{
                    this.$message({
                      type:'error',
                      showClose:true,
                      duration:10000,
                      message:res
                    });
                  }
                }
              )
            }).catch(() => {
            });
          },
          selectWorkDate(time){
            const dateTime = new Date();
            const year = dateTime.getFullYear();
            const month = dateTime.getMonth();
            const lastTime =  year + "-" + this.addZero(month) + "-01";
            return (time > new Date(lastTime));
          },
          batchInfo(){
            this.batchForm.frozenMonth = null;
            this.modelBatch = true;
          },
          submitFrozenForm(formName){
            this.$refs[formName].validate((valid) => {
              if (valid) {
                this.batchFrozenInfo();
              } else {
                return false;
              }
            });
          },
          batchFrozenInfo(){
            let params = {
              currMonth : this.batchForm.frozenMonth,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            let url = `${this.$store.state.islhurl}labourHour/batchFrozenInfo`
            this._post(url,params).then(
              res => {
                if(res=="200"){
                  this.modelBatch = false;
                  this.getLabourHourByPage();
                  this.$Message.success('Labour Hour Frozen Successful')
                }else{
                  this.$message({
                      type:'error',
                      showClose:true,
                      duration:10000,
                      message:res
                    });
                }
              }
            )
          },
          submitUnfrozenForm(formName){
            this.$refs[formName].validate((valid) => {
              if (valid) {
                this.batchUnfrozenInfo();
              } else {
                return false;
              }
            });
          },
          batchUnfrozenInfo(){
            let params = {
              currMonth : this.batchForm.frozenMonth,
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            let url = `${this.$store.state.islhurl}labourHour/batchUnfrozenHour`
            this._post(url,params).then(
              res => {
                if(res=="200"){
                  this.modelBatch = false;
                  this.getLabourHourByPage();
                  this.$Message.success('Labour Hour Unfrozen Successful')
                }else{
                  this.$message({
                      type:'error',
                      showClose:true,
                      duration:10000,
                      message:res
                    });
                }
              }
            )
          },
          handleSelectionChange(val) {
            this.multipleSelection = val;
          },
          exportExcel(){
            this.exportLoading = true;
            let execlName = 'LabourHourInfo.xlsx';
            const length = this.multipleSelection.length;
            let ids = [];
            for (let i = 0; i < length; i++) {
              ids.push(this.multipleSelection[i].id)
            }
            let workTime1 = null,workTime2 = null;
            if(this.workTime != null && this.workTime != '' && this.workTime.length > 0){
              workTime1 = this.workTime[0];
              workTime2 = this.workTime[1];
            }
            this.$axios({
              url: `${this.$store.state.islhurl}labourHour/exportInfoGroup`,
              method: 'post',
              data: {
                ids: ids,
                projectId: this.projectNumber==''?null:this.projectNumber,
                taskId: this.taskNumber==''?null:this.taskNumber,
                subtaskId: this.subtaskNumber==''?null:this.subtaskNumber,
                workTime1: workTime1,
                workTime2: workTime2,
                projectName: this.projectName==''?null:this.projectName,
                serviceContractNo: this.serviceContractNo==''?null:this.serviceContractNo,
                createUser: this.createUser==''?null:this.createUser,
                country: this.country==''?null:this.country,
                dept: this.department==''?null:this.department,
                flagStatus: this.flagStatus==''?null:this.flagStatus,
                islhToken : sessionStorage.getItem('islhtoken'),
              },
              responseType:"blob"
            }).then(response=>{
              this.exportLoading = false;
              const blob = new Blob([response.data])
              const aEle = document.createElement('a');     // 创建a标签
              const href = window.URL.createObjectURL(blob);       // 创建下载的链接
              aEle.href = href;
              aEle.download = execlName;  // 下载后文件名
              document.body.appendChild(aEle);
              aEle.click();     // 点击下载 
              document.body.removeChild(aEle); // 下载完成移除元素
              window.URL.revokeObjectURL(href) // 释放掉blob对象
            })
          },
          advancedFilter(){
            if(this.queryShow){
              this.queryShow = false;
              this.country = null;
              this.department = null;
              this.flagStatus = null;
              this.workTime = [];
            }else{
              this.queryShow = true;
            }
          },
          close(){
            this.$refs.batchForm.resetFields();
            this.modelBatch = false;
          },
          changePage (val) {
            this.currentPage = val;
            this.getLabourHourByPage();
          },
          // 改变当前页显示条数
          changePageSize (val) {
            this.pageSize = val;
            this.getLabourHourByPage();
          },
          remoteEngineer(query) {
            if (query !== '') {
              setTimeout(() => {
                this.EngineerList = this.LaborEngineerList.filter(item => {
                  return item.userCode.toLowerCase().indexOf(query.toLowerCase()) > -1 || item.displayName.toLowerCase().indexOf(query.toLowerCase()) > -1;
                });
              }, 200);
            } else {
              this.EngineerList = this.LaborEngineerList;
            }
          },
          addZero (v) {
            return v < 10 ? '0' + v : v;
          }
        },
    }
</script>



// WEBPACK FOOTER //
// src/view/labour/labourList.vue